import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import PropTypes from 'prop-types';
import GalleryNavigator from '../GalleryNavigator';
import GalleryCarousel from '../GalleryCarousel';

const useStyles = makeStyles(theme => ({
  content: {
    display: 'flex',
    flexDirection: 'row',
  },
  cardHeader: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    paddingTop: theme.spacing(3),
  },
  buttonWrapper: {
    justifyContent: 'flex-end',
  },
  appLogo: {
    maxWidth: '200',
    maxHeight: '3em',
  },
  productGallery: {
    flex: 2,
    paddingRight: theme.spacing(3),
  },
  productDescription: {
    paddingLeft: theme.spacing(3),
    flex: 1,
  },
  imageCarousel: {
    width: '100%',
  },
  fab: {
    margin: theme.spacing(0, 0, 0, 1),
  },
}));

export default function InstalledAppCard(props) {
  const classes = useStyles();
  const { handleChange, expanded, panelId, handleDemoFormClick, app } = props;

  const [activeStep, setActiveStep] = React.useState(0);
  const formattedSlides = app.meta.slides.map(slide => ({
    title: slide.title,
    description: [slide.copy],
    imgPath: slide.img,
  }));
  const productScreenshots = formattedSlides;
  // TODO: Discuss how this needs to be done
  const logo = require(`../../assets/images/${app.meta.logo}`); // eslint-disable-line import/no-dynamic-require, global-require
  const productScreenshot = productScreenshots[activeStep];
  return (
    <ExpansionPanel square expanded={expanded === panelId} onChange={handleChange(panelId)}>
      <ExpansionPanelSummary aria-controls={`${panelId}-content`} id={`${panelId}-header`}>
        <div className={classes.cardHeader}>
          <img src={logo} alt="App Logo" className={classes.appLogo} />
          <div>
            <Button
              variant="contained"
              onClick={e => {
                handleDemoFormClick(e);
                e.stopPropagation();
              }}
              color="primary"
            >
              GET A DEMO
            </Button>
          </div>
        </div>
      </ExpansionPanelSummary>
      <ExpansionPanelDetails>
        <div className={classes.content}>
          <div className={classes.productGallery}>
            <GalleryCarousel
              activeStep={activeStep}
              productScreenshots={productScreenshots}
              setActiveStep={setActiveStep}
            />
            <GalleryNavigator
              activeStep={activeStep}
              productScreenshots={productScreenshots}
              setActiveStep={setActiveStep}
            />
          </div>
          <div className={classes.productDescription}>
            <Typography variant="h6" paragraph component="h4">
              {productScreenshot.title}
            </Typography>
            {productScreenshot.description.map((text, i) => (
              // eslint-disable-next-line react/no-array-index-key
              <Typography variant="body2" key={`${i}-text`} paragraph component="p">
                {text}
              </Typography>
            ))}
          </div>
        </div>
      </ExpansionPanelDetails>
    </ExpansionPanel>
  );
}

InstalledAppCard.propTypes = {
  app: PropTypes.shape({
    name: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    auth: PropTypes.shape({ default: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string])) }),
    meta: PropTypes.shape({
      logo: PropTypes.string.isRequired,
      link: PropTypes.string.isRequired,
      slides: PropTypes.arrayOf(
        PropTypes.oneOfType([
          PropTypes.shape({
            title: PropTypes.string.isRequired,
            copy: PropTypes.string.isRequired,
            img: PropTypes.string.isRequired,
          }),
        ])
      ),
    }),
  }).isRequired,
  handleChange: PropTypes.func.isRequired,
  handleDemoFormClick: PropTypes.func.isRequired,
  expanded: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]).isRequired,
  panelId: PropTypes.string.isRequired,
};
